import LeonidaAccettazioneList from "../accettazione/components/LeonidaAccettazioneList.vue";
import LeonidaAccettazioneEdit from "../accettazione/components/LeonidaAccettazioneEdit.vue";
import LeonidaAccettazioneView from "../accettazione/components/LeonidaAccettazioneView.vue";

export default {
    LeonidaAccettazioneList,
    LeonidaAccettazioneEdit,
    LeonidaAccettazioneView,
};
